/**
 * Preset profile images and uploads are sometimes stored as app-relative paths (/images/...).
 * Embedded widgets on customer sites resolve those against the wrong origin — always persist absolute URLs.
 */
export function ensureAbsoluteAppAssetUrl(url: string | null | undefined): string {
  if (url == null || typeof url !== "string") return "";
  const t = url.trim();
  if (!t) return "";
  if (t.startsWith("data:") || t.startsWith("http://") || t.startsWith("https://")) {
    return t;
  }
  if (t.startsWith("/")) {
    const base =
      (typeof process !== "undefined" &&
        process.env.NEXT_PUBLIC_APP_URL?.replace(/\/+$/, "")) ||
      "https://app.easygpt.builders";
    return `${base}${t}`;
  }
  return t;
}
